import React from 'react'
import { injectState } from 'freactal'
import app from '../../../../feathers'
import { hasElement } from '../../../../lib'
import { Checkbox } from 'react-mdl'

const units = app.service('units')
class FormativePracticalContent extends React.Component {
  state = {
    formativePracticalMapping: [],
  }

  componentDidMount() {
    this.initialMapping()
  }

  componentWillReceiveProps() {
    this.initialMapping()
  }

  initialMapping = () =>
    this.setState({
      formativePracticalMapping: this.props.state.unit
        .formativePracticalAssessment,
    })

  handleChangeFormativePracMapping = async (e, taskIndex) => {
    const { _id } = this.props.state.unit
    const { unitElement } = this.props
    const isChecked = e.target.checked
    const op = isChecked ? '$push' : '$pull'
    await units.patch(_id, {
      [op]: {
        [`formativePracticalAssessment.${taskIndex}.mapping`]: unitElement,
      },
    })
  }

  render() {
    const { formativePracticalMapping } = this.state
    const { unitElement } = this.props

    return (
      <tbody>
        {formativePracticalMapping.map(({ name, items, mapping }, i) => [
          <tr key={`formativePractical-${i}`}>
            <td>
              <Checkbox
                onChange={e => this.handleChangeFormativePracMapping(e, i)}
                checked={hasElement(unitElement, mapping)}
              />
            </td>
            <td>
              Task {i + 1}
            </td>
            <td>
              {name}
            </td>
          </tr>,
        ])}
      </tbody>
    )
  }
}

export default injectState(FormativePracticalContent)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/MappingModal/FormativePracticalContent.js